import { useMediaQuery } from "@/hooks/use-media-query";

const WHATSAPP_NUMBER = "919816672006";
const DEFAULT_MESSAGE = "Hi Best Escape Holidays! I'd like to know more about your tour packages.";

export function WhatsAppButton({ hideOnMobile = false }) {
  const isDesktop = useMediaQuery("(min-width: 1024px)");
  if (hideOnMobile && !isDesktop) return null;
  const link = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(DEFAULT_MESSAGE)}`;
  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-chat-button"
      aria-label="Chat with us on WhatsApp"
      className="fixed bottom-24 left-4 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] shadow-lg transition-transform hover:scale-105 active:scale-95 lg:bottom-6"
    >
      <span className="absolute inset-0 -z-10 animate-ping rounded-full bg-[#25D366] opacity-40" />
      <svg viewBox="0 0 32 32" className="h-8 w-8 fill-white">
        <path d="M16.004 2.667c-7.363 0-13.333 5.97-13.333 13.333 0 2.36.62 4.573 1.706 6.494L2.67 29.333l7.03-1.845a13.24 13.24 0 0 0 6.304 1.605h.006c7.362 0 13.333-5.97 13.333-13.333S23.366 2.667 16.004 2.667Zm7.79 18.836c-.33.93-1.63 1.708-2.667 1.936-.703.15-1.62.27-4.716-1.014-3.957-1.638-6.502-5.646-6.7-5.913-.196-.267-1.6-2.133-1.6-4.07s1.014-2.89 1.373-3.286c.359-.396.784-.495 1.045-.495.26 0 .522.002.75.014.24.012.563-.09.88.673.33.79 1.122 2.744 1.222 2.944.1.2.166.435.033.7-.13.267-.198.435-.396.667-.198.233-.417.52-.596.7-.198.196-.404.409-.174.804.23.396 1.026 1.694 2.202 2.744 1.514 1.35 2.79 1.77 3.196 1.968.406.198.644.166.882-.1.238-.267 1.02-1.19 1.293-1.596.273-.406.545-.336.917-.202.372.135 2.353 1.11 2.758 1.31.406.2.677.298.775.465.099.166.099.966-.23 1.896Z" />
      </svg>
    </a>
  );
}
